




import { Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class Tooltip extends Vue {
  @Prop({default:''}) public title: string;
  @Prop({default:null}) public target: HTMLElement;
  @Prop({default:'right'}) public placement: string;

  hover :boolean = false;
  onShow(ev :any){
    var el = ev.relatedTarget  as HTMLElement;
    el.addEventListener('mouseenter', this.onHover);
    el.addEventListener('mouseleave', this.onHoverOut);    
    //tooltipエレメントがbody直下に作成され、独立したスタッキングコンテクストになるのでzIndexを適切にセットする必要がある
    el.style.zIndex = String.format('{0}',this.$api.getMaxZIndex() + 210); //グローバルメニューが200のため、オフセット100=>210に変更
  }
  
  onHide(ev :any){

    if (this.hover) {
      ev.preventDefault();
      return;
    }
    var el = ev.relatedTarget  as HTMLElement;
    el.removeEventListener('mouseenter', this.onHover);
    el.removeEventListener('mouseleave', this.onHoverOut);    
  }
  onHover(){
    this.hover = true;
  }
  onHoverOut() {
    if(this.hover){
      this.$root.$emit('bv::hide::tooltip');
    }
    this.hover = false;
  }
}
